import { css as o } from "@microsoft/fast-element";
import { designTokens as r } from "../../design-tokens.js";
import { display as t } from "@matrix42/fast-foundation";
import { normalize as e } from "../../common/normalize.js";
import { typography as l } from "../../styles/typography.js";
const y = o`
  ${e}
  ${t("table-row")}
  :host {
    /* Style */
    text-align: left;
    color: ${r.color.neutral[500]};
    /* Typography */
    ${l("p", "regular")}
`;
export {
  y as tableRowStyles
};
